// extracted by mini-css-extract-plugin
export default {"container":"UserProfiles_container__g11JN","content":"UserProfiles_content__XqeB5","dstv_logo":"UserProfiles_dstv_logo__5D5Ym"};